module.exports = __webpack_public_path__ + "img/game-application-development.05c44067.png";